import { FB_REQUEST_TYPES, FORM_FIELDS, PAGE } from '../../../../constants';
import { PERIOD_SOURCE, PURPOSE_SOURCE } from '../../../../constants/sources';
import { fb } from '../../../../helpers/client';
import { sourceNameByValue } from '../../../../helpers';
import analytics from '../../../../helpers/analytics';
import { postMessage, PostMessageType } from '../../../../helpers/whitelable';
import { getStore } from '../../../../store/client';
import { formDataToFb } from '../../../../store/adapters/formStore';
import { checkAbAdditionalQuestions } from '../../../../helpers/experiments/additional.questions';

export { ParamsStepView } from './view';
export { schema } from './schema';

export const fbSendRequest = (isWhitelable?: boolean) => {
    const { userId, fbPayload, formData } = getStore().getState().formStore;
    fb.sendRequest(FB_REQUEST_TYPES.CONTACT, formDataToFb(formData), { userId, ...fbPayload }).then((response) => {
        if (isWhitelable) {
            postMessage({
                type: PostMessageType.hid,
                userId,
                result: response.id,
            });
        }
    });
};

export const onNext = async () => {
    const { formStore } = getStore().getState();
    const { withoutAnalytics, page, formData, autoRun } = formStore;

    const isShowAdditionalQuestions = checkAbAdditionalQuestions('1');

    const isWhitelabel = page == PAGE.WHITELABEL;

    const purpose = sourceNameByValue(formData[FORM_FIELDS.PURPOSE], PURPOSE_SOURCE);

    fbSendRequest(isWhitelabel);

    if ([PAGE.WHITELABEL, PAGE.WAYBACK].includes(page as any)) {
        postMessage({
            type: PostMessageType.framePageCompleted,
            result: { page_number: 1 },
        });
    }

    if (page == 'avito') {
        postMessage({
            type: PostMessageType.event,
            label: 'broker_form_contacts_submit',
        });
    }

    if (!withoutAnalytics) {
        const period = sourceNameByValue(formData[FORM_FIELDS.PERIOD], PERIOD_SOURCE);
        const fillType = autoRun ? 'Проброс' : 'Ручное';

        analytics.emit({
            event: analytics.events.mainEvent,
            eventCategory: [PAGE.CARDS_RESTORE].includes(page as any)
                ? analytics.categories.CreditCard
                : analytics.categories.Loan,
            eventAction: 'Шаг 1|Параметры',
            eventLabel: [
                fillType,
                `Сумма кредита - ${formData[FORM_FIELDS.AMOUNT]}`,
                `На какой срок - ${period}`,
                `Город получения - ${formData[FORM_FIELDS.REGION]}`,
                `Цель кредита - ${purpose}`,
                ...(isShowAdditionalQuestions
                    ? [`Когда нужны деньги - ${formData[FORM_FIELDS.WHEN_MONEY_NEEDED]}`]
                    : []),
                `Отчество - ${formData[FORM_FIELDS.MIDDLE_NAME] === null ? 'нет' : 'да'}`,
            ].join('|'),
        });
    }

    return true;
};
